import { createActionThunk } from "redux-thunk-actions";
import {
  DAILY_SUM_INITIALIZATION,
  GET_DAILY_SUMMARY_USERS,
  DAILY_SUMMARY_USER_SELECTED,
  DAILY_SUMMARY_DATE_CHANGED,
} from "./constant";
import { getNutrientsList } from "../services/MealPlannerService";
import { getData } from "../services/DailySummaryService";
import { getUser as getSymptomUsersService } from "../services/UserService";

// const initialize = () => {
//   return (dispatch) => {
//     dispatch({
//       type: DAILY_SUM_INITIALIZATION,
//     });
//   };
// };
// const getDailySummaryUsers = (id) => {
//   return async (dispatch) => {
//     var data = await getUser(id);
//     dispatch({
//       type: GET_DAILY_SUMMARY_USERS,
//       data: data,
//     });
//   };
// };
const initialize = createActionThunk(
  DAILY_SUM_INITIALIZATION,
  async (date, userID) => {
    const nutrientsList = await getNutrientsList();
    const data = await getData(date, userID);
    return { nutrientsList, data };
  }
);
const getDailySummaryUsers = createActionThunk(
  GET_DAILY_SUMMARY_USERS,
  async (_id) => {
    let users = await getSymptomUsersService(_id);
    return { users };
  }
);
const selectUser = (_id, group) => {
  return (dispatch) => {
    dispatch({
      type: DAILY_SUMMARY_USER_SELECTED,
      data: {
        _id: _id,
        group,
      },
    });
  };
};

const onDateChange = (val) => {
  return (dispatch) => {
    dispatch({
      type: DAILY_SUMMARY_DATE_CHANGED,
      val: val,
    });
  };
};

export default { initialize, getDailySummaryUsers, selectUser, onDateChange };



// WEBPACK FOOTER //
// ./src/actions/dailyInputSummaryActions.js